import GooglePublisherTag from "./google-publisher-tag.jsx";
import pure from "./higher-order/pure";
import React from "react";

var tournamentListSizeMappings = [
  [[768, 0], [[728, 90], [468, 60]]],
  [[0, 0], [[468, 60], [320, 50], [300, 250], [300, 100], [234, 60], [88, 31]]],
];

export default pure(function TournamentListBanner({ list, session, tags }) {
  var tag = tags.valueSeq().find(t => t.get("name") === list);
  if (tag) {
    var banner = tag.get("marquee_html");
    if (banner && banner.length > 0) {
      /* eslint-disable react/no-danger */
      return (
        <div className="l-wrapper batch-g batch-g--align-center" dangerouslySetInnerHTML={{ __html: banner}} />
      );
      /* eslint-enable react/no-danger */
    }
  }

  return <BannerForSession session={session} />;
});

function BannerForSession({ session }) {
  var targeting = {
    "logged-in": session.get("user_id") !== undefined,
    "user-state": session.getIn(["billing_address", "state"])
  };

  // Note: the defaultWidth/defaultHeight we really want is 728x90.
  // Here we add 4px to both to support the borders, which are included in the height that's set by the ad.
  // We need the borders to be set on the actual ad div so when it's "display:none;" we don't get a visible rectangle artifact
  return (
    <GooglePublisherTag
      adUnitPath={window.env.adUnitBasePath + "/tournament-list"}
      className="marquee_item"
      sizeMappings={tournamentListSizeMappings}
      targeting={targeting} />
  );
}
